import * as ScrollArea from '@radix-ui/react-scroll-area';
import clsx from 'clsx';
import type { Ref } from 'react';

import * as styles from './index.css';

export const ScrollableRoot = ({
  ref,
  children,
  className,
  ...props
}: ScrollArea.ScrollAreaProps & { ref?: Ref<HTMLDivElement> }) => {
  return (
    <ScrollArea.Root
      {...props}
      ref={ref}
      className={clsx(className, styles.scrollableContainerRoot)}
    >
      {children}
    </ScrollArea.Root>
  );
};

export const ScrollableViewport = ({
  ref,
  children,
  className,
  ...props
}: ScrollArea.ScrollAreaViewportProps & { ref?: Ref<HTMLDivElement> }) => {
  return (
    <ScrollArea.Viewport
      {...props}
      ref={ref}
      className={clsx(className, styles.scrollableViewport)}
    >
      {children}
    </ScrollArea.Viewport>
  );
};

export const ScrollableScrollbar = ({
  ref,
  children,
  className,
  ...props
}: ScrollArea.ScrollAreaScrollbarProps & { ref?: Ref<HTMLDivElement> }) => {
  return (
    <ScrollArea.Scrollbar
      orientation="vertical"
      {...props}
      ref={ref}
      className={clsx(className, styles.scrollbar)}
    >
      <ScrollArea.Thumb className={styles.scrollbarThumb} />
      {children}
    </ScrollArea.Scrollbar>
  );
};

export const Scrollable = {
  Root: ScrollableRoot,
  Viewport: ScrollableViewport,
  Scrollbar: ScrollableScrollbar,
};
